module.exports = __webpack_public_path__ + "static/img/pic_home_wanshui.cb5f45a.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/pic_home_wanshui.png
// module id = RAfz
// module chunks = 83